module.exports = __webpack_public_path__ + "static/media/1_CAM-BUV-050 Induction PFP_Graph.e01dd83f.png";